import type { GetAllPartiesByDistributionV2Response } from 'wg-api-sdk';

import PartyItem from './PartyItem';

type Props = {
  parties: Maybe<GetAllPartiesByDistributionV2Response['items']>;
  onSubmit: (
    party: GetAllPartiesByDistributionV2Response['items'][number],
  ) => void;
};

export default function SelectParty({ parties, onSubmit }: Props) {
  return (
    <div className="flex h-full w-full flex-col gap-1.5">
      {parties?.map((party) => (
        <PartyItem
          key={party.id}
          party={party}
          onClick={() => onSubmit(party)}
        />
      ))}
    </div>
  );
}
